import eventEmitter, { types } from './eventEmitter'
import i18n from './i18n'

/*
 * Eine Rueckfrage stellen und auf die Antwort warten.
 *
 * Gezeigt wird sie von `UI/ConfirmDialog`, das einmal in App.js haengt. Der
 * Umweg ueber den Ereignisverteiler erspart es jeder Ansicht, ein eigenes
 * Fenster mitzuschleppen — gebraucht wird nur `if (await askConfirm(...))`.
 */
export function askConfirm({ title, text, confirmLabel, cancelLabel, tone, prompt } = {}) {
	return new Promise(resolve => {
		eventEmitter.emit(types.openConfirmDialog, {
			title,
			text,
			confirmLabel,
			cancelLabel,
			tone,
			// Mit `prompt` loest die Frage mit dem eingetippten Text auf statt mit
			// true — siehe askReason weiter unten.
			prompt,
			resolve
		})
	})
}

/*
 * Die Rueckfrage vor dem Verwerfen: "Es gibt ungespeicherte Aenderungen."
 *
 * true = verwerfen und schliessen, false = weiter bearbeiten.
 *
 * Die Texte kommen ueber `i18n.t` statt ueber den Haken `useTranslation`, weil
 * die Frage aus einer Ablaufkette heraus gestellt wird und nicht beim Rendern.
 */
export function askDiscardChanges() {
	return askConfirm({
		title: i18n.t('Discard unsaved changes?'),
		text: i18n.t('This window contains changes that have not been saved yet.'),
		confirmLabel: i18n.t('Discard changes'),
		cancelLabel: i18n.t('Continue editing'),
		tone: 'danger'
	})
}

/**
 * Eine Rueckfrage, die eine Begruendung verlangt.
 *
 * Liefert den eingetippten Text oder `null`, wenn abgebrochen wurde. Gedacht
 * fuer Handlungen, die jemand anderem etwas wegnehmen: Wer den Nachweis einer
 * Schueler:in beanstandet oder entfernt, muss sagen, warum — der Satz geht an
 * die Schueler:in und in den Verlauf der Junior Company.
 */
export async function askReason({ title, text, label, placeholder, confirmLabel, tone } = {}) {
	const antwort = await askConfirm({
		title,
		text,
		confirmLabel,
		tone,
		prompt: {
			label: label || i18n.t('Reason'),
			placeholder,
			error: i18n.t('Please give a reason.')
		}
	})

	return typeof antwort === 'string' ? antwort : null
}
